import {Component, ComponentOptions} from "@mecatran-components/component";
import { Table, DataTable, Cell } from "@mecatran-components/table";
import {UtilsWeb} from "SRC/services/utils/index.web.mjs";  



export class ScheduleTable extends Component{
    constructor(scheduleTableOptions){
        var scheduleTableOptions = scheduleTableOptions || {};
        var options = new ComponentOptions(); 
        options.setDomOptions(scheduleTableOptions.domOptions); 
        super(options);
        this.initScheduleTable(scheduleTableOptions);
    }
    // ==========
    // private 
    // ----------
    setItineraryGroup(itineraryGroup){ this.itineraryGroup = itineraryGroup; }

    getItineraryGroup(){ return this.itineraryGroup; }


    setDisplayAllStops(b){ this.displayAllStops = b }

    getDisplayAllStops(){ return this.displayAllStops; }

    getItineraries(){ 
        var itineraryGroup = this.getItineraryGroup();
        if (itineraryGroup) return itineraryGroup.getItineraries();
        else return;
    }

    getCutoffDate(){ 
        var itineraryGroup = this.getItineraryGroup();
        if (itineraryGroup) return itineraryGroup.getCutoffDate();
        else return;
    }

    initScheduleTable(scheduleTableOptions){    
        this.setItineraryGroup(scheduleTableOptions.itineraryGroup);
        this.setDisplayAllStops(scheduleTableOptions.displayAllStops);

        this.buildContent(); // build the content
        //this.build();
    }

    // ==========
    // overload
    // ----------
    createContainerNode(domOptions){
        var div = document.createElement('div');
        UtilsWeb.setDomOptions(div,domOptions)
        return div;
    }


    createContentNode(){
        var itineraries = this.getItineraries();
        if (itineraries){
            var cutoffDate = this.getCutoffDate();
            var displayAllStops = this.getDisplayAllStops();
            var schoolStation = undefined;
            var homeStation = undefined; // permet uniquement de savoir s'il faut afficher l'arrêt ou non 
            var { header, dataColumn } = itineraries[0].toTable(homeStation, schoolStation, {displayAllStops}, cutoffDate );
            var rows = itineraries.map((itinerary)=>itinerary.toTable(homeStation, schoolStation, {displayAllStops}, cutoffDate ).dataColumn);
            rows = [header].concat(rows);    
            var dataTable = new DataTable({ data: rows, dataType: 'column', ignoreMerge : true});
            var table = new Table({dataTable});
            return table.getDomManager().getDomNode(); 
        }
        return;
    }

}



/**
 * scheduleTableOptions interface
 * ------------------------------
 * itineraryGroup
 * displayAllStops
 * domOptions  
 */
class ScheduleTableOptions{}

